<template>
  <div>
    <PageTitle :pageTitle="pageTitle" :breadcrumbName="breadcrumbName" class="mb-2"/>

    <div class="card columns gap2 mb-1">
      <div class="span-5">
        <h5 class="mb-1 flex ai-c jc-sb text-uppercase text-medium">
          RELATÓRIO GERAL DOS PROCESSOS DE IMPORTAÇÃO
        </h5>
        <p class="text-light text-sm">Quantidade de Processos de Importação do Filtro:
          <strong>{{ processes.length }} processos</strong></p>
      </div>

      <div class="span-7 warning-bg lt-pd">
        <h5>
          <span class="text-sm text-right">
            <span class="text-bold">
            Para que os Procesos de Importação sejam exibidos
            </span>
            <br/>
            Por Etapa: Digite no campo Pesquisa (Invoice, Ref Pedido, BL/AWB/CRT, Exportador, Fabricante, Nº DI e/ou Nº DUIMP)
            Por Período: Selecione um campo de Data e um Período Inicial e Final.
          </span>
        </h5>
      </div>

      <div class="span-12 filters-row flex ai-c fgap2 fw-w">
        <div>
          <Select
            v-model="selectedCompaniesIds"
            :multiple="true"
            :classLi="'blured-select-list'"
            :options="userCompanies"
            title="Empresas"
          />
        </div>
        <div>
          <Select
            :value="filtroEtapa.value"
            :options="generateSteps"
            :useIcon="true"
            title="Etapas"
            @input="changeFiltroEtapa"
          >
            <template #icon>
              <MapBoxIcon/>
            </template>
          </Select>
        </div>
        <div>
          <Select title="Tipo de Filtro" v-model="tipoFiltro" :options="tiposFiltro"/>
        </div>
        <div v-if="tipoFiltro === 'filtroGeral'">
          <StyledInput class="rounded" name="generalSearch" type="text"
                       placeholder="Digite a Palavra Chave" v-model="generalSearchInput"/>
        </div>
        <template v-if="tipoFiltro === 'porPeriodo'">
          <div>
            <Select title="Tipo de Data" v-model="filtroCampo" :options="listOfDatesFields"
                    :useIcon="true">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
          <div class="date-picker">
            <Select title="Data Inicial" v-model="filtroDataInicial" :useIcon="true" :useDate="true">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
          <div class="date-picker">
            <Select title="Data Final" v-model="filtroDataFinal" :useIcon="true" :useDate="true">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
        </template>
        <div class="flex ai-c fgap1">
            <button class="btn medium solid primary flex ai-c jc-c useHint" type="button" @click="drawerOpen = true">
                <svg class="feather feather-list" fill="none" height="24" stroke="currentColor" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <line x1="8" x2="21" y1="6" y2="6"></line>
                    <line x1="8" x2="21" y1="12" y2="12"></line>
                    <line x1="8" x2="21" y1="18" y2="18"></line>
                    <line x1="3" x2="3.01" y1="6" y2="6"></line>
                    <line x1="3" x2="3.01" y1="12" y2="12"></line>
                    <line x1="3" x2="3.01" y1="18" y2="18"></line>
                </svg>
                <div class="hint text-sm">Gerenciar colunas</div>
            </button>
            <button class="btn medium solid primary" v-if="tipoFiltro === 'filtroGeral'" @click="submitSearchGeneralFilter">GERAR
            </button>
            <button class="btn medium solid primary" v-else @click="submitSearchDataFilter">GERAR
            </button>
            <download-excel
                class="btn solid success btn-exportar"
                :data="processes"
                :fields="showingColumnsFieldsExcel"
                name="relatorio-processos-importacao.xls"
                :fetch="startDownload"
            >
                GERAR EXCEL
            </download-excel>
        </div>
      </div>
        <v-drawer
            title="Gerenciar colunas"
            :handler="drawerOpen"
            @close="drawerOpen = false"
        >
            <template #content>
                <div class="flex fgap2" style="min-width: 650px;">
                    <div class="flex1">
                        <h6 class="mb-2">Colunas ativas</h6>
                        <input v-model="filterShowColumns" class="mb-2 input-filter" name="hided-columns" placeholder="Pesquisar" type="text">
                        <ul class="column-list nolist">
                        <draggable v-model="myList" @change="onDragChange">
                            <template>
                                <li v-for="column in showingColumns" :key="column?.isMultipleKey == true ? column?.key[0].field : column?.key">
                                    <label class="flex ai-c fgap1">
                                        <input :checked="!column.hide" :name="column.name" :value="column.name" type="checkbox" @input="clicked">
                                        {{ column.name }}
                                    </label>
                                </li>
                            </template>
                        </draggable>
                        </ul>
                    </div>
                    <div class="flex1">
                        <h6 class="mb-2">Colunas inativas</h6>
                        <input v-model="filterHideColumns" class="mb-2 input-filter" name="hided-columns" placeholder="Pesquisar" type="text">
                        <ul class="column-list remove-cursor-move">
                        <template>
                            <li v-for="column in hidedColumns" :key="column?.isMultipleKey == true ? column?.key[0].field : column?.key">
                                <label class="flex ai-c fgap1">
                                    <input :checked="!column.hide" :name="column.name" :value="column.name" type="checkbox"
                                    @input="clicked">
                                    {{ column.name }}
                                </label>
                            </li>
                        </template>
                        </ul>
                    </div>
                    </div>
            </template>
            <template #footer>
               <div class="flex fd-c">
                <Label>Dicas</Label>
                <ul style="list-style-type: disc; margin-left: 20px; line-height: 1.5; font-size: 0.9rem;">
                    <li>Arraste e solte para organizar as colunas ativas</li>
                    <li>Para mostrar uma coluna, marque a caixa de seleção</li>
                    <li>Para esconder uma coluna, desmarque a caixa de seleção</li>
                </ul>
               </div>
            </template>
        </v-drawer>
    </div>
    <div class="card columns gap2 mb-2">
      <div class="span-12">
        <Table :columns="myList" :data="processes" tableClass="vgt-table center text-sm text-table text-medium sm-pd">
          <template #identification="{ item }">
            {{ item.typeOfProcess | typeOfProcess }}{{ String(item.identification).padStart(5, '0') }}
          </template>
          <template #customer.name="{ item }">
            <span :class="{ blured: presentationMode }">
              {{ item.customer.name }}
            </span>
          </template>
          <template #exporter.name="{ item }">
            <span :class="{ blured: presentationMode }">
              {{ item.exporter.name }}
            </span>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

// eslint-disable-next-line import/no-cycle
import api from '@/services/api';
import { REPORTS_MODULE_PERMISSION_CODE } from '@/constants/portalPermissions';
import { PROCESSES_REPORT_COLUMN_FIELD_CODES } from '@/constants/processesReportFieldPermissions';
import {
  resolveCompaniesIdsForApi,
  resolveFieldPermissionCodes,
  resolveSelectedCompanyIds,
} from '@/utils/portalPermissionAccess';
import Table from '@/components/Table.vue';
import PageTitle from '@/components/PageTitle.vue';
import StyledInput from '@/components/DataInput/StyledInput.vue';
import Select from '@/components/DataInput/Select.vue';

import * as labelsOfImportProcess from '@/utils/DateLabelsUtil';
import ProcessesReportColumnsExcel from '@/utils/ProcessesReportColumnsExcel';
import VDrawer from "@/components/VDrawer.vue";
import draggable from 'vuedraggable';

import {
  MapBoxIcon,
  CalendarIcon,
} from '@/components/Icons';
import { boolean } from 'yup/lib/locale';

export default {
  components: {
    Table,
    PageTitle,
    StyledInput,
    Select,
    CalendarIcon,
    MapBoxIcon,
    VDrawer,
    draggable
  },
  computed: {
    ...mapState(['presentationMode']),
    ...mapState('process', ['processes', 'steps']),
    ...mapState('auth', ['user', 'companyPermissions']),
    ...mapGetters('auth', ['permittedCustomerCompaniesForModule']),
    userCompanies() {
      const customerCompanies = this.permittedCustomerCompaniesForModule(REPORTS_MODULE_PERMISSION_CODE)
        .map((company) => ({
          label: company.name.toUpperCase(),
          value: company.id,
        }));

      return [
        { label: 'TODAS', value: '' },
        ...customerCompanies,
      ];
    },
    resolvedCompanyIds() {
      return resolveSelectedCompanyIds(
        this.permittedCustomerCompaniesForModule(REPORTS_MODULE_PERMISSION_CODE),
        this.selectedCompaniesIds,
      );
    },
    allowedFieldCodes() {
      return resolveFieldPermissionCodes(this.companyPermissions, this.resolvedCompanyIds);
    },
    permittedColumns() {
      const allowed = this.allowedFieldCodes;

      if (allowed === null) {
        return this.columns;
      }

      return this.columns.filter((column) => {
        const code = PROCESSES_REPORT_COLUMN_FIELD_CODES[column.name];
        return code && allowed.has(code);
      });
    },
    generateSteps() {
      return this.steps.filter((step) => step.id !== 9).map((step) => (
        { label: step.description, value: step.id }
      ));
    },
    listOfDatesFields() {
      const data = new Array(0);
      if (this.labels !== undefined) {
        // eslint-disable-next-line no-restricted-syntax
        for (const prop in this.labels) {
          if (this.labels[prop].type === 'date') {
            data.push(this.labels[prop]);
          }
        }
      }
      return data;
    },
    myList: {
      get() {
        if (this.filterShowColumns !== '') {
          return this.showColumns.filter((item) => String(item.name).match(new RegExp(this.filterShowColumns, 'gi')));
        }
        return this.showColumns;
      },
      set() {},
    },
    hidedColumns() {
      if (this.filterHideColumns !== '') {
        return this.hideColumns.filter((item) => String(item.name).match(new RegExp(this.filterHideColumns, 'gi')));
      }
      return this.hideColumns;
    },
    showingColumns() {
      if (this.filterShowColumns !== '') {
        return this.showColumns.filter((item) => String(item.name).match(new RegExp(this.filterShowColumns, 'gi')));
      }
      return this.showColumns;
    },
    showingColumnsFieldsExcel() {
        if (this.showColumns.length > 0) {
            // Criar um mapa para ordenação
            const orderMap = new Map();
            this.showColumns.forEach((col, index) => {
            orderMap.set(col.key, index);
            });

            return Object.entries(this.fieldsExcel)
                    .filter(([_, value]) => this.showColumns.some(col => col.key === value.fieldFilter))
                    .sort(([_, a], [__, b]) => {
                        const orderA = orderMap.get(a.fieldFilter);
                        const orderB = orderMap.get(b.fieldFilter);
                        return orderA - orderB;
                    })
                    .reduce((acc, [key, value]) => {
                        acc[key] = value;
                        return acc;
                    }, {});
        }
    return this.fieldsExcel;
    },
  },
  data() {
    return {
      filtroEtapa: { label: 'Todas', value: 8 },
      selectedCompaniesIds: [],
      generalSearchInput: '',
      filtroCampo: '',
      teste: '',
      filtroDataInicial: '',
      filtroDataFinal: '',
      filterHideColumns: '',
      filterShowColumns: '',
      showColumns: [],
      hideColumns: [],
      tipoFiltro: 'filtroGeral',
      drawerOpen: false,
      tiposFiltro: [
        {
          label: 'Palava Chave',
          value: 'filtroGeral',
        },
        {
          label: 'Por Período',
          value: 'porPeriodo',
        },
      ],
      labels: {
        id: {
          label: 'ID',
        },
        ...labelsOfImportProcess.labels[0],
      },
      columns: [
        {
          name: 'Ref. Prime',
          key: 'identification',
          width: 100,
          isDate: false,
          hide: false,
        },
        {
          name: 'Etapa',
          key: 'step.description',
          isDate: false,
          hide: false,
        },
        {
          name: 'Empresa',
          key: 'customer.name',
          isDate: false,
          hide: false,
        },
        {
          name: 'Exportador',
          key: 'exporter.name',
          isDate: false,
          hide: false,
        },
        {
          name: 'Ref. Pedido',
          key: 'customerRef',
          isDate: false,
          hide: false,
        },
        {
          name: 'Outras referências',
          key: 'anotherRef',
          isDate: false,
          hide: false,
        },
        {
          name: 'Status',
          key: 'status',
          isDate: false,
          hide: false,
        },
        {
          name: 'Invoice',
          key: 'invoice',
          isDate: false,
          hide: false,
        },
        {
          name: 'Moeda',
          key: 'cifValueCurrency',
          isDate: false,
          hide: false,
        },
        {
          name: 'Via de Transporte',
          key: 'wayOfTransport',
          isDate: false,
          hide: false,
        },
        {
          name: 'Incoterm',
          key: 'incoterm',
          hide: false,
        },
        {
          name: 'Forwarder',
          key: 'freightForwarder.name',
          hide: false,
        },
        {
          name: 'CNTR',
          key: 'typeOfBoarding',
          hide: false,
        },
        {
          name: 'Data de Abertura',
          key: 'created',
          isDate: true,
          hide: false,
        },
        {
          name: 'Previsão da Prontidão de Carga',
          key: 'datesEstimatedGoodsReadinesDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'ETD',
          key: 'datesETD',
          isDate: true,
          hide: false,
        },
        {
          name: 'ETA',
          key: 'datesETA',
          isDate: true,
          hide: false,
        },
        {
          name: 'Previsão da Entrega',
          key: 'datesEstimatedCustomerDeliverDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'Previsão de Numerário',
          key: 'estimatedStepCashRequest',
          isDate: true,
          hide: false,
        },
        {
          name: 'Prontidão de Carga',
          key: 'datesGoodsReadinesDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'Coleta',
          key: 'datesCargoCollectDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'Embarque',
          key: 'datesDepartureDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'Chegada',
          key: 'datesArrivalDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'Nº DI / DUIMP',
          key: [
            {field: 'diNumber', fieldValidate: 'duimp', valueValidation: false},
            {field: 'duimpIdentification', fieldValidate: 'duimp', valueValidation: true},
          ],
          isMultipleKey: true,
          hide: false,
        },
        {
          name: 'Versão DUIMP',
          key: 'duimpVersion',
          hide: false,
        },
        {
          name: 'Chave Duimp',
          key: 'duimpAccessKey',
          hide: false,
        },
        {
          name: 'Nº do Protocolo',
          key: [
            {field: 'diProtocol', fieldValidate: 'duimp', valueValidation: false},
          ],
          isMultipleKey: true,
          hide: false,
        },
        {
          name: 'Data de Registro',
          key: [
            {field: 'diRegistryDate', fieldValidate: 'duimp', valueValidation: false},
            {field: 'duimpRegistryDate', fieldValidate: 'duimp', valueValidation: true},
          ],
          isDate: true,
          isMultipleKey: true,
          hide: false,
        },
        {
          name: 'Data de Desembaraço',
          key: [
            {field: 'diResourcefulnessDate', fieldValidate: 'duimp', valueValidation: false},
            {field: 'duimpResourcefulnessDate', fieldValidate: 'duimp', valueValidation: true},
          ],
          isDate: true,
          isMultipleKey: true,
          hide: false,
        },
        {
          name: 'Canal',
          key: [
            {field: 'diChannel', fieldValidate: 'duimp', valueValidation: false},
            {field: 'duimpChannel', fieldValidate: 'duimp', valueValidation: true},
          ],
          isMultipleKey: true,
          hide: false,
        },
        {
          name: 'Carregamento',
          key: 'datesGoodsLoadingDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'Entrega no Cliente',
          key: 'datesCustomerDeliverDate',
          isDate: true,
          hide: false,
        },
        {
          name: 'Valor CIF',
          key: 'cifValue',
          isMoney: true,
          hide: false,
        },
      ],
      fieldsExcel: ProcessesReportColumnsExcel,
    };
  },
  filters: {
    typeOfProcess(value) {
      switch (value) {
        case 'CONTA_E_ORDEM':
          return 'PRI';

        case 'ENCOMENDA':
          return 'E';

        case 'ASSESSORIA':
          return 'A';

        default:
          return 'PRI';
      }
    },
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
    breadcrumbName: {
      type: String,
      default: '',
    },
  },
  watch: {
    selectedCompaniesIds: {
      handler() {
        this.applyColumnPermissions();
      },
      deep: true,
    },
    tipoFiltro: {
        handler() {
            this.filtroCampo = '';
            this.filtroDataInicial = '';
            this.filtroDataFinal = '';
            this.generalSearchInput
        },
        deep: true,
        immediate: true
    }
  },
  methods: {
    ...mapActions('process', ['updateProcesses', 'getSteps']),
    ...mapActions(['toggleLoading']),
    applyColumnPermissions() {
      const existingHideState = new Map();
      [...this.showColumns, ...this.hideColumns].forEach((column) => {
        existingHideState.set(column.name, column.hide);
      });

      const permitted = this.permittedColumns.map((column) => ({
        ...column,
        hide: existingHideState.has(column.name) ? existingHideState.get(column.name) : column.hide,
      }));

      this.showColumns = permitted.filter((column) => !column.hide);
      this.hideColumns = permitted.filter((column) => column.hide);
    },
    getSelectedCustomersIds() {
      return resolveCompaniesIdsForApi(
        this.permittedCustomerCompaniesForModule(REPORTS_MODULE_PERMISSION_CODE),
        this.selectedCompaniesIds,
      );
    },
    getStepsIdsParam() {
      const stepId = this.filtroEtapa.value;
      if (stepId === 8 || stepId === '8') {
        return '7,2,1,3,4,5,11,10,6';
      }
      return stepId;
    },
    isStepConcluido() {
      const stepId = this.filtroEtapa.value;
      return stepId === 6 || stepId === '6';
    },
    hasSpecificStepFilter() {
      const stepId = this.filtroEtapa.value;
      return stepId !== 8 && stepId !== '8';
    },
    appendFilterParams(params) {
      let result = params;

      result += `&customersIds=${this.getSelectedCustomersIds()}`;

      if (!this.isStepConcluido()) {
        result += `&stepsIds=${this.getStepsIdsParam()}`;
      }

      return result;
    },
    applyClientSideFilters(processes) {
      let result = processes;

      const customersIds = this.getSelectedCustomersIds();
      const ids = customersIds.split(',').map(Number);
      result = result.filter((process) => process.customer && ids.includes(process.customer.id));

      const stepIdsList = String(this.getStepsIdsParam()).split(',').map(Number);
      result = result.filter((process) => {
        const stepId = process.step && process.step.id !== undefined
          ? process.step.id
          : process.step;
        return stepIdsList.includes(Number(stepId));
      });

      return result;
    },
    changeFiltroEtapa(value) {
      const step = this.steps.find((item) => item.id === value);
      if (step) {
        this.filtroEtapa = { label: step.description, value: step.id };
      }
    },
    async submitSearchGeneralFilter() {
        if (this.generalSearchInput !== '') {
            this.toggleLoading(true);
            const params = this.appendFilterParams(`concluidos=true&q=${encodeURIComponent(this.generalSearchInput)}`);
            const route = `/customers/import/search?${params}`;
            const response = await api.get(route);
            const { data } = response.data;
            this.updateProcesses(this.applyClientSideFilters(data));
            this.toggleLoading(false);
            return;
        }

        if (this.hasSpecificStepFilter() && !this.isStepConcluido()) {
            this.toggleLoading(true);
            const params = this.appendFilterParams('concluidos=false');
            const route = `/customers/import/report/general?${params}`;
            const response = await api.get(route);
            this.updateProcesses(response.data.data);
            this.toggleLoading(false);
            return;
        }

        if (this.isStepConcluido()) {
            this.$swal.fire({
                title: 'Campo Vazio',
                text: 'Para a etapa Concluídos, informe uma palavra-chave ou selecione um período.',
                icon: 'warning',
                showConfirmButton: true,
                confirmButtonColor: 'var(--primary-color)',
            });
            return;
        }

        this.$swal.fire({
            title: 'Campo Vazio',
            text: 'Por favor, insira uma palavra-chave para pesquisa.',
            icon: 'warning',
            showConfirmButton: true,
            confirmButtonColor: 'var(--primary-color)',
        });
    },
    async submitSearchDataFilter() {
        this.generalSearchInput = '';
        if (this.filtroCampo !== '' && this.filtroDataInicial !== '' && this.filtroDataFinal !== '') {
            this.toggleLoading(true);
            const dataInicial = `${moment(this.filtroDataInicial, 'DD/MM/YYYY').format('Y-MM-DDT')}00:00:00`;
            const dataFinal = `${moment(this.filtroDataFinal, 'DD/MM/YYYY').format('Y-MM-DDT')}23:00:00`;
            const concluidosParam = this.isStepConcluido() ? 'concluidos=true' : 'concluido=true';
            const params = this.appendFilterParams(`${concluidosParam}&field=${this.filtroCampo}&from=${dataInicial}&to=${dataFinal}`);
            const route = `/customers/import/report/general?${params}`;
            const response = await api.get(route);
            this.updateProcesses(response.data.data);
            this.toggleLoading(false);
        } else {
            let html = '<div class="text-left pl-4 pr-4 pt-1"><p style="margin-bottom: 20px;">Por favor, preencha os campos abaixo!</p>';
            html += '<ul style="list-style-type: disc; margin-left: 30px;">';
            if (this.isStepConcluido()) {
                html += '<li class="mb-1">Para a etapa Concluídos, informe uma palavra-chave ou selecione um período.</li>';
            }
            if(this.filtroCampo === '') {
                html += '<li class="mb-1">Tipo de data é obrigatório.</li>';
            }
            if(this.filtroDataInicial === '') {
                html += '<li class="mb-1">Data inicial é obrigatória.</li>';
            }
            if(this.filtroDataFinal === '') {
                html += '<li class="mb-1">Data final é obrigatória.</li>';
            }
            html += '</ul></div>';
            this.$swal.fire({
                title: 'Campo Vazio',
                html: html,
                icon: 'warning',
                showConfirmButton: true,
                confirmButtonColor: 'var(--primary-color)',
            });
        }
    },
    onDragChange(props) {
      const columns = [...this.showColumns].filter(col => col != null);
      const indexColumnsProps = columns.findIndex((col) =>
        col.isMultipleKey === true
          ? col.key[0].field === props.moved.element.key[0].field
          : col.key === props.moved.element.key
      );
      const element = columns[indexColumnsProps];
      columns.splice(indexColumnsProps, 1);
      columns.splice(props.moved.newIndex, 0, element);
      this.showColumns = columns;
    },
    clicked(e) {
      const column = this.getColumn(e.target.value);
      if (column) {
        column.hide = !column.hide;
        this.toggleColumnVisibility(column);
      }
    },
    getColumn(name) {
      return this.showColumns.find((col) => col.name === name)
            || this.hideColumns.find((col) => col.name === name);
    },
    toggleColumnVisibility(column) {
      const isVisible = this.showColumns.includes(column);
      const array = isVisible ? this.showColumns : this.hideColumns;
      const index = array.indexOf(column);
      array.splice(index, 1);
      const otherArray = isVisible ? this.hideColumns : this.showColumns;
      otherArray.splice(isVisible ? 0 : otherArray.length, 0, column);
    },
    async startDownload() {
        if(this.tipoFiltro === 'filtroGeral') {
            await this.submitSearchGeneralFilter();
        } else {
            await this.submitSearchDataFilter();
        }
        return this.processes;
    },
  },
  async created() {
    await this.getSteps();
  },
  mounted() {
    this.updateProcesses([]);
    this.applyColumnPermissions();
  },
  destroyed() {
    this.updateProcesses([]);
  },
};
</script>

<style scoped>
.div-buttons {
  margin-top: 4px;
}

.filters-row > div {
  flex: 0 0 auto;
}

.date-picker {
  min-width: 310px;
}

.column-list{
    border: var(--input-border);
    border-bottom: 0;
}

.column-list li {
    border-bottom: var(--input-border);
}

.column-list li:hover {
    background-color: var(--primary-color);
    color: var(--white-color);
}

.column-list label {
  margin-bottom: 0;
  padding: 0.5rem;
  font-size: 0.9rem;
  cursor: move;
}

.remove-cursor-move label {
  cursor: pointer !important;
}

.column-list input {
  cursor: pointer;
}

.input-filter {
    height: 2.3125rem;
}

</style>
